import { Route, Routes } from "react-router";

import { AnalyticsLandingPage } from "./pages/AnalyticsLandingPage";
import { CustomerCockpitPage } from "./pages/CustomerCockpitPage";

/**
 * The Analytics area, mounted at `/analytics/*` (CHT-2027, ADR 0017):
 *   /analytics                the customer picker
 *   /analytics/:customerId    the customer's cockpit (`?tab=overview|explore|events&range=...`)
 */
export function AnalyticsRoutes() {
  return (
    <Routes>
      <Route index element={<AnalyticsLandingPage />} />
      <Route path=":customerId" element={<CustomerCockpitPage />} />
    </Routes>
  );
}
